import { render, staticRenderFns } from "./kyc-certification-list.vue?vue&type=template&id=5be3c28c&"
import script from "./kyc-certification-list.vue?vue&type=script&lang=js&"
export * from "./kyc-certification-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports